<template lang="pug">
  .flow-builder-action-show-products-template
    template-tools(v-if="!disabled", @delete="$emit('delete')")
    .template-platforms-container.badges.mb-3(v-if="disabled")
      b-badge(v-for="(platform) in selectedPlatformsObjects.slice(0, sliceEnd)", :key="platform.platform_id", :style="{'background-color': platformColor(platform.name, 0.7)}") {{ platform.title }}
      b-badge(v-if="selectedPlatformsObjects.slice(sliceEnd).length", variant="soft-secondary") {{ selectedPlatformsObjects.slice(sliceEnd).length }} más
    .template-platforms-container.overflow-x.no-wrap.mb-3(v-else)
      b-form-group
        label.text-help.text-sm Plataformas donde se usará este template:
        k-select.disabled-white.flush(placeholder="- Agregar plataformas -", :options="parsedPlatforms", :disabled="disabled", :value="selected_platforms", @input="updatePlatforms", multiple, :limit="3", :searchable="false")
    b-card.mb-0.no-shadow.w-100.bg-light-white
      .bg-white.mb-3
        p.mb-0 Encuesta de satisfacción
        p.text-secondary.text-sm Encuesta para obtener retroalimentación del usuario.
        fieldset.mb-3(:disabled="disabled")
          b-form-group.mb-1(label-size="sm", label="Título:", v-for="template_attribute in Template_Attributes", :key="template_attribute.template_attribute_id", v-if="template_attribute.name === 'title'")
            vue-tribute(:options="tributeOpts")
              b-form-input(size="sm", placeholder="Título", :value="template_attribute.value", @blur="updateTemplateAttribute(template_attribute, $event)")
          b-form-group.mb-1(label-size="sm", label="Subtítulo:", v-for="template_attribute in Template_Attributes", :key="template_attribute.template_attribute_id", v-if="template_attribute.name === 'subtitle'")
            vue-tribute(:options="tributeOpts")
              b-form-input(size="sm", placeholder="Subtítulo", :value="template_attribute.value", @blur="updateTemplateAttribute(template_attribute, $event)")
          b-form-group.mb-1(label-size="sm", label="Título de botón:", v-for="template_attribute in Template_Attributes", :key="template_attribute.template_attribute_id", v-if="template_attribute.name === 'button_title'")
            vue-tribute(:options="tributeOpts")
              b-form-input(size="sm", placeholder="Título de botón", :value="template_attribute.value", @blur="updateTemplateAttribute(template_attribute, $event)")
          b-form-group.mb-1(label-size="sm", label="Tipo de encuesta:", v-for="template_attribute in Template_Attributes", :key="template_attribute.template_attribute_id", v-if="template_attribute.name === 'rating_type'")
            b-form-select(size="sm", :value="template_attribute.value || null", @change="selectRating(template_attribute, $event)")
              option(:value="null", disabled) Selecciona tipo
              option(v-for="(type, index) in question_types", :key="index", :value="type.value") {{type.title}}
          b-form-group.mb-1(label-size="sm", label="Tipo de evaluación:", v-for="template_attribute in Template_Attributes", :key="template_attribute.template_attribute_id", v-if="template_attribute.name === 'score_option'", :disabled="!score_types.length")
            b-form-select(size="sm", :value="template_attribute.value || null", @change="update(template_attribute, $event)")
              option(:value="null", disabled) Selecciona tipo
              option(v-for="(type, index) in score_types", :key="index", :value="type.value") {{type.title}}
          b-form-group.mb-1(label-size="sm", label="Etiqueta de evaluación:", v-for="template_attribute in Template_Attributes", :key="template_attribute.template_attribute_id", v-if="template_attribute.name === 'score_label'", :disabled="!score_types.length")
            b-form-select(size="sm", :value="template_attribute.value || null", @change="update(template_attribute, $event)")
              option(:value="null", disabled) Selecciona tipo
              option(v-for="(type, index) in label_types", :key="index", :value="type.value") {{type.title}}
          b-form-group.mb-1(label-size="sm", label="Pregunta (encuesta):", :description="description", v-for="(template_attribute, index) in Template_Attributes", :key="index", v-if="template_attribute.name === 'question_text'")
            vue-tribute(:options="tributeOpts")
              b-form-input(size="sm", placeholder="Pregunta", :value="template_attribute.value", @blur="updateTemplateAttribute(template_attribute, $event)")
          b-form-group.mb-1(label-size="sm", label="Aviso de privacidad:", v-for="template_attribute in Template_Attributes", :key="template_attribute.template_attribute_id", v-if="template_attribute.name === 'privacy_url'")
            vue-tribute(:options="tributeOpts")
              b-form-input(size="sm", placeholder="URL aviso de privacidad", :value="template_attribute.value", @blur="updateTemplateAttribute(template_attribute, $event)")
          b-form-checkbox(switch, v-for="template_attribute in Template_Attributes", :key="template_attribute.template_attribute_id", v-if="template_attribute.name === 'has_free_form'", :checked="parseBoolean(template_attribute.value)", @change="update(template_attribute, $event)") Aceptar comentarios
      template-connector(v-for="connector in Template_Connectors", :key="connector.template_connector_id", v-bind="connector", :block_id="block_id", :disabled="disabled")
</template>

<script>
import templateCommon from '@/helpers/template-common'
import TemplateTools from '@/components/templates/common/Tools.vue'
import Connector from "./connectors/Connector"
import ResultDescription from "./helpers/ResultDescription"
import _debounce from 'lodash.debounce'

export default {
  mixins: [templateCommon],
  data () {
    return {
      question_types: [
        {value: 'csat', title: 'Customer Satisfaction Score (indicador de satisfacción del cliente)'},
        {value: 'nps', title: 'Net Promoter Score (lealtad del cliente)'},
        {value: 'ces', title: 'Customer Effort Score (nivel de facilidad de la experiencia)'},
      ],
      label_types: [
        {value: 'neg_pos', title: 'Negativo - Positivo'},
        {value: 'hard_easy', title: 'Difícil - Fácil'},
        {value: 'dis_sat', title: 'Insatisfecho - Satisfecho'},
        {value: 'unlike_like', title: 'Improbable - Probable'},
        {value: 'poor_great', title: 'Poco - Mucho'},
        {value: 'bag_good', title: 'Mala - Excelente'},
        {value: 'none', title: 'Ninguna'}
      ]
    }
  },
  computed: {
    description () {
      let template_attribute = this.getAttribute('rating_type')
      if (template_attribute && template_attribute.value) {
        let example = 'Ejemplo: '
        switch (template_attribute.value) {
          case "csat":
            return example += '¿Cómo calificarías tu experiencia con el chatbot?'
          case "nps":
            return example += '¿Nos recomendarías con algún amigo?'
          case "ces":
            return example += 'En general ¿Qué tan fácil fue resolver tu problema?'
          default:
            return '';
        }
      }
      return ''
    },
    score_types () {
      let rating_type = this.getAttribute('rating_type')
      if(rating_type && rating_type.value) {
        switch (rating_type.value){
          case "csat":
            return [
              {value: 'one_to_five', title: 'De 1 a 5'},
              {value: 'five_stars', title: '5 estrellas'},
              {value: 'five_emojis', title: '5 emojis'},
            ]
          case "nps":
            return [ {value: 'zero_to_ten', title: 'De 0 a 10'} ]
          case "ces":
            return [ {value: 'one_to_seven', title: 'De 1 a 7'} ]
          default:
            return []
        }
      }
      return []
    },
  },
  components: {
    'template-connector': Connector,
    TemplateTools,
    ResultDescription
  },
  created () {
    this.updateTemplateAttribute = _debounce((template_attribute, value) => {
      const newValue = value.target._value
      const attribute = JSON.parse(JSON.stringify(template_attribute))
      attribute.value = value.target._value

      this.update(template_attribute, newValue)
      this.updateAttribute(this.block_id, this.template_id, attribute).then(() => {
        this.$message.success('Actualizado')
      })
    }, 100, { leading: false, trailing: true })
  },
  methods: {
    update (template_attribute, value) {
      template_attribute.value = value
      const attribute = JSON.parse(JSON.stringify(template_attribute))
      attribute.value = value

      this.updateAttribute(this.block_id, this.template_id, attribute)

      this.$message.success('Actualizado')
    },
    selectRating (template_attribute, value) {
      this.update(template_attribute, value)
      let attr_template = this.getAttribute('rating_type')

      if (attr_template) return this.update(attr_template, null)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
